<mode-labeled-menu
  class="palette-selector"
  label=""
  [selected]="selectedItem"
  [menuItems]="menuItems"
  [buttonHeight]="buttonHeight"
  [label]="label"
  (menuChange)="onPaletteSelected($event)"
></mode-labeled-menu>